/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
import { MetaData } from "../Courses/GetAllRequests";
export type StudentsDTO = {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  img_url: string;
  phone: string;
  country: string;
  password: string;
  confirmPassword: string;
  status: string;
  createdAt: string;
  lastVisited: string;
  updatedAt: string;
  lastCountry: string;
  birthDate: string;
  jobTitle: string;
  isBlocked: boolean;
  ipRestrictionException: boolean;
};

export interface StudentsData {
  data: StudentsDTO[];
  metaData: MetaData;
}

export interface StudentsResponse {
  data?: StudentsData;
  error?: ApiError;
}

export interface GetStudentsParams {
  page: number;
  limit: number;
  firstName?: string;
  status?: string;
  phone?: string;
  email?: string;
}

export const getStudents = async ({
  page,
  limit,
  firstName,
  status,
  phone,
  email,
}: GetStudentsParams): Promise<StudentsResponse> => {
  try {
    const response = await axios.get(`/student/all`, {
      params: { page, limit, firstName, status, phone, email },
    });
    return { data: response.data };
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
